//Componentes generales
import React, { useEffect, useState } from "react";

import moment from "moment";

//Permisos
import {
  EDITA_COMPROBANTE,
  MODIFICA_ESTADO_COMPROBANTE,
  MODIFICA_COMPROBANTE_ESTADO_RECHAZADO,
  MODIFICA_GRUPOS_COMPROBANTES,
  REENVIO_MOVIPORT,
} from "../../utils/permisos";

const RenderRow = ({
  usuario,
  index,
  style,
  listTDoc,
  filter,
  checkPermisos,
  cambiarEstado,
  editar,
  verDetalles,
  statesNEviables,
  sendToAPI,
  disabledElements,
  cambiarGrupos,
}) => {
  const [currentLista, setCurrentLista] = useState(listTDoc ? listTDoc : []);
  const [disabledElementsReq, setDisabledElementsReq] =
    useState(disabledElements);
  const [disabledButtonEnviar, setDisabledButtonEnviar] = useState(false);

  useEffect(() => {
    setCurrentLista(listTDoc ? listTDoc : []);
  }, [listTDoc]);

  useEffect(() => {
    setDisabledElementsReq(disabledElements);
  }, [disabledElements]);

  if (currentLista && currentLista.length > 0) {
    const formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    currentLista.map((tdoc) => {
      tdoc.importeString = formatter.format(tdoc.importe ? tdoc.importe : 0); //Se crea a modo visual la propiedad importeString.
    });
    if (filter === "") {
      return (
        <div style={style}>
          <div className="container-r-list-item">
            <div className="container-r-list-item-header">
              <div className="r-list-item-header-clave">
                {currentLista[index].tDocCodFor +
                  " - " +
                  currentLista[index].tDocNroFor}
              </div>
              <div className="container-codOri-observada">
                <div className="r-list-item-header-title">
                  {currentLista[index].codOri}
                </div>
                {currentLista[index].observada && (
                  <div className="r-list-item-details-observada">OBSERVADA</div>
                )}
              </div>
              <div className="r-list-item-details-clave">
                {currentLista[index].state}
              </div>
            </div>
            <div>
              <div className="container-r-list-item-details">
                <div className="r-list-item-details-title">
                  Alta:{" "}
                  {moment(currentLista[index].fecAlt).format("DD-MM-YYYY")}
                </div>
                <div className="r-list-item-details-title">
                  Emisión:{" "}
                  {moment(currentLista[index].dateOfIssue).format("DD-MM-YYYY")}
                </div>
                <div className="r-list-item-details-title">
                  Importe: $ {currentLista[index].importeString}
                </div>
                <div className="r-list-item-details-title">
                  Emitido por:{" "}
                  {currentLista[index].user[0].fullName.length > 25
                    ? currentLista[index].user[0].fullName.slice(0, 22) + "..."
                    : currentLista[index].user[0].fullName}
                </div>
                <div className="r-list-item-details-title">
                  Grupos:{" "}
                  {currentLista[index].gruposV
                    .map((grupo) => grupo.name)
                    .join(" | ")}
                </div>
              </div>
            </div>
            <div></div>
            <div className="container-r-list-item-btn">
              {(usuario.userType.some(
                (item) =>
                  MODIFICA_ESTADO_COMPROBANTE.includes(item.typeName) &&
                  currentLista[index].state == "PENDIENTE"
              ) || (
                currentLista[index].state == "RECHAZADO" &&
                usuario.userType.some((item) =>
                  MODIFICA_COMPROBANTE_ESTADO_RECHAZADO.includes(item.typeName)
                )
              )) && (
                <div
                  className={`r-list-item-btn-A ${
                    disabledElementsReq ? "navbar-container-disabled" : ""
                  }`}
                  onClick={() =>
                    !disabledElements
                      ? cambiarEstado(currentLista[index])
                      : null
                  }
                >
                  Modificar Estado
                </div>
              )}
              {currentLista[index].state == "PENDIENTE" && (
                <div
                  className={`${"r-list-item-btn-A"} ${
                    disabledElementsReq ? "navbar-container-disabled" : ""
                  }`}
                  onClick={() =>
                    !disabledElements ? editar(currentLista[index]) : null
                  }
                >
                  Editar
                </div>
              )}
              <div
                className={`${"r-list-item-btn-A"} ${
                  disabledElementsReq ? "navbar-container-disabled" : ""
                }`}
                onClick={() =>
                  !disabledElements ? verDetalles(currentLista[index]) : null
                }
              >
                Detalles
              </div>
              {checkPermisos(MODIFICA_GRUPOS_COMPROBANTES) && (
                <div
                  className={`r-list-item-btn-A ${
                    disabledElementsReq ? "navbar-container-disabled" : ""
                  }`}
                  onClick={() =>
                    !disabledElements
                      ? cambiarGrupos(currentLista[index])
                      : null
                  }
                >
                  Modificar Grupos
                </div>
              )}
            </div>
            {checkPermisos(REENVIO_MOVIPORT) &&
              !statesNEviables.includes(currentLista[index].state) &&
              currentLista[index].enviado === false && (
                <div
                  className={`${"container-resend"} ${
                    disabledElementsReq || disabledButtonEnviar
                      ? "navbar-container-disabled"
                      : ""
                  }`}
                  onClick={async () => {
                    setDisabledButtonEnviar(true);
                    if (!disabledElements || !disabledButtonEnviar) {
                      await sendToAPI(currentLista[index]);
                    }
                    setDisabledButtonEnviar(false);
                  }}
                >
                  {"Enviar >>>"}
                </div>
              )}
          </div>
        </div>
      );
    } else {
      const req_filters = currentLista.filter(
        (r) =>
          r.tDocCodFor
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(filter.toLowerCase().replace(/\s+/g, "")) ||
          (
            r.tDocCodFor.toLowerCase() +
            "-" +
            r.tDocNroFor.toString().toLowerCase().replace(/\s+/g, "")
          ).includes(filter.toLowerCase().replace(/\s+/g, "")) ||
          r.tDocNroFor
            .toString()
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(filter.toLowerCase().replace(/\s+/g, "")) ||
          r.codOri
            .toString()
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(filter.toLowerCase().replace(/\s+/g, ""))
      );
      return (
        <div style={style}>
          <div className="container-r-list-item">
            <div className="container-r-list-item-header">
              <div className="r-list-item-header-clave">
                {req_filters[index].tDocCodFor +
                  " - " +
                  req_filters[index].tDocNroFor}
              </div>
              <div className="container-codOri-observada">
                <div className="r-list-item-header-title">
                  {req_filters[index].codOri}
                </div>
                {req_filters[index].observada && (
                  <div className="r-list-item-details-observada">OBSERVADA</div>
                )}
              </div>
              <div className="r-list-item-details-clave">
                {req_filters[index].state}
              </div>
            </div>
            <div>
              <div className="container-r-list-item-details">
                <div className="r-list-item-details-title">
                  Alta: {moment(req_filters[index].fecAlt).format("DD-MM-YYYY")}
                </div>
                <div className="r-list-item-details-title">
                  Emisión:{" "}
                  {moment(req_filters[index].dateOfIssue).format("DD-MM-YYYY")}
                </div>
                <div className="r-list-item-details-title">
                  Importe: $ {req_filters[index].importeString}
                </div>

                <div className="r-list-item-details-title">
                  Emitido por:{" "}
                  {req_filters[index].user[0].fullName.length > 25
                    ? req_filters[index].user[0].fullName.slice(0, 22) + "..."
                    : req_filters[index].user[0].fullName}
                </div>
                <div className="r-list-item-details-title">
                  Grupos:{" "}
                  {req_filters[index].gruposV
                    .map((grupo) => grupo.name)
                    .join(" | ")}
                </div>
              </div>
            </div>
            <div className="container-r-list-item-btn">
              {(usuario.userType.some(
                (item) =>
                  MODIFICA_ESTADO_COMPROBANTE.includes(item.typeName) &&
                  req_filters[index].state == "PENDIENTE"
              ) || (
                req_filters[index].state == "RECHAZADO" &&
                usuario.userType.some((item) =>
                  MODIFICA_COMPROBANTE_ESTADO_RECHAZADO.includes(item.typeName)
                )
              )) && (
                <div
                  className={`r-list-item-btn-A ${
                    disabledElementsReq ? "navbar-container-disabled" : ""
                  }`}
                  onClick={() =>
                    !disabledElements ? cambiarEstado(req_filters[index]) : null
                  }
                >
                  Modificar Estado
                </div>
              )}
              {req_filters[index].state == "PENDIENTE" && (
                <div
                  className={`${"r-list-item-btn-A"} ${
                    disabledElementsReq ? "navbar-container-disabled" : ""
                  }`}
                  onClick={() =>
                    !disabledElements ? editar(req_filters[index]) : null
                  }
                >
                  Editar
                </div>
              )}
              <div
                className={`${"r-list-item-btn-A"} ${
                  disabledElementsReq ? "navbar-container-disabled" : ""
                }`}
                onClick={() =>
                  !disabledElements ? verDetalles(req_filters[index]) : null
                }
              >
                Detalles
              </div>
              {checkPermisos(MODIFICA_GRUPOS_COMPROBANTES) && (
                <div
                  className={`r-list-item-btn-A ${
                    disabledElementsReq ? "navbar-container-disabled" : ""
                  }`}
                  onClick={() =>
                    !disabledElements ? cambiarGrupos(req_filters[index]) : null
                  }
                >
                  Modificar Grupos
                </div>
              )}
            </div>
            {checkPermisos(REENVIO_MOVIPORT) &&
              !statesNEviables.includes(req_filters[index].state) &&
              req_filters[index].enviado === false && (
                <div
                  className={`${"container-resend"} ${
                    disabledElementsReq || disabledButtonEnviar
                      ? "navbar-container-disabled"
                      : ""
                  }`}
                  onClick={async () => {
                    setDisabledButtonEnviar(true);
                    if (!disabledElements || !disabledButtonEnviar) {
                      await sendToAPI(req_filters[index]);
                    }
                    setDisabledButtonEnviar(false);
                  }}
                >
                  {"Enviar >>>"}
                </div>
              )}
          </div>
        </div>
      );
    }
  }
};

export default RenderRow;